module.exports = __webpack_public_path__ + "static/main-campus-archive-mb-seminary00041-29f93984439d3abec14be1c6586d216c.jpg";